const templateUrl = require('./unsent-shipment-header.html');

const app = angular.module('msi.shipments.unsentShipmentHeader', []);

app.component('ogUnsentShipmentHeader', {
  bindings: {
    shipment: '=ogFor'
  },
  templateUrl: templateUrl
});

module.exports = app.name;
